import {
	IconButton,
	List,
	ListItem,
	ListItemButton,
	ListItemText,
	TableBody,
	TableCell,
	TableRow,
} from "@mui/material";
import { BaseTable } from "../../../components/table";
import { ManualChargePostingApprovalTablePropsType } from "../../../types/container.type";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { formatAmountDisplay } from "../../../helpers/formatAmountDisplay";

export const ManualChargePostingApprovalTable: React.FC<
	ManualChargePostingApprovalTablePropsType
> = ({
	rows,
	handleActionButtonClick,
	selectedChargeId,
	dropdownRef,
	handleActionItemClick,
}) => {
	const actions = ["Approve", "Decline"];
	const manualChargePostingApprovalTableHeaders = [
		"Charge Name",
		"Product",
		"Charge Mode",
		"Amount",
		"Action",
	];

	return (
		<BaseTable headers={manualChargePostingApprovalTableHeaders}>
			<TableBody>
				{rows?.map((row, index) => (
					<TableRow key={index}>
						<TableCell>{row?.name}</TableCell>
						<TableCell>{row?.productName}</TableCell>
						<TableCell>{row?.mode}</TableCell>
						<TableCell>{formatAmountDisplay(row?.amount ?? 0)}</TableCell>
						<TableCell>
							<IconButton
								sx={{
									borderRadius: "0.5rem",
									backgroundColor: "var(--sky-blue-color)",
									"&:hover": {
										backgroundColor: "var(--sky-blue-color)",
									},
								}}
								onClick={(e) =>
									handleActionButtonClick(e, {
										id: row?.id,
										name: row?.name,
										type: row?.type,
										amount: row?.amount,
										institution: row?.institution,
									})
								}
							>
								<MoreVertIcon
									sx={{
										color: "#FFFFFF",
										display: "inline-flex",
									}}
								/>
							</IconButton>
							{selectedChargeId && selectedChargeId === row?.id && (
								<List
									component={"ul"}
									ref={dropdownRef}
									className="dropdown-modal"
								>
									{actions.map((action, index) => (
										<ListItem
											key={index}
											onClick={(e) =>
												handleActionItemClick(e, selectedChargeId, action)
											}
										>
											<ListItemButton>
												<ListItemText primary={action} />
											</ListItemButton>
										</ListItem>
									))}
								</List>
							)}
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</BaseTable>
	);
};
